import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { RequestExceptionWithResponse } from '@eika-infrastruktur/request';

import { CardAccount } from '../generated-types';
import { getCreditCardAccounts } from '../services/creditCardsService';

export const useCreditCards = (enabled = true): UseQueryResult<CardAccount[], RequestExceptionWithResponse> =>
    useQuery({
        queryKey: ['credit-cards'],
        queryFn: () => getCreditCardAccounts(),
        enabled,
    });
